export default __webpack_public_path__ + "static/media/about-2.c767ba1d.png";